var exports = {
  "sx": "Radio__0NcstL",
  "az": "Box__t7OTWk",
  "EY": "Text__b3u7ca",
  "wy": "Box_1__ZlJw1G",
  "JU": "Label__uWvXZ_",
  "ND": "focusVisible__2LruaA",
  "sp": "isSelected__xGloGl",
};

module.exports = exports;
